const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  try { return await navigator.serviceWorker.register("/sw.js"); } catch { return null; }
};

export const enablePush = async (staffFetch) => {
  const reg = await registerServiceWorker();
  if (!reg) throw new Error("المتصفح لا يدعم الإشعارات");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("تم رفض إذن الإشعارات — فعّله من إعدادات المتصفح ثم أعد المحاولة");
  const r = await fetch(`${API}/push/vapid-public-key`);
  if (!r.ok) throw new Error("الإشعارات غير مهيأة على الخادم");
  const { public_key } = await r.json();
  let sub;
  try {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8(public_key),
    });
  } catch (e) {
    throw new Error("تعذر الاشتراك في خدمة الإشعارات — " + (e?.message || "حاول مرة أخرى"));
  }
  await staffFetch("/staff/push/subscribe", {
    method: "POST",
    body: JSON.stringify({ subscription: sub.toJSON() }),
  });
  return true;
};
